export default __webpack_public_path__ + "static/media/51.ec43ffc7.jpg";